import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MailRecordEntity } from './mail-record.entity';

@Index('_email', ['email'], {})
@Index('_unique_external_source_id', ['externalSourceId'], { unique: true })
@Entity('_mail_source')
export class MailSourceEntity extends BaseEntity {
	@Column('varchar', { name: '_type', length: 50 })
	public type!: string;

	@Column('varchar', {
		name: '_externalSourceId',
		nullable: true,
		unique: true,
		length: 191,
	})
	public externalSourceId!: string | null;
	@Column('varchar', { name: '_email', length: 191 })
	public email!: string;

	@Column('varchar', { name: '_state', length: 20 })
	public state!: string;

	@Column('datetime', {
		name: '_lastEvent',
		nullable: true,
		default: () => 'CURRENT_TIMESTAMP',
	})
	public lastEvent!: Date | null;

	@OneToMany(
		() => MailRecordEntity,
		(mailRecord) => mailRecord.fkMailSource,
		{},
	)
	public mailRecords!: Array<MailRecordEntity>;
}
